import MainCarousel from './mainCarousel';
import HomeCont from './HomeContent';

function Home() {
    // club header and navbar
    return (
        <div>
            <MainCarousel />
            <HomeCont />
        </div>
    );
}

export default Home;
